// JavaScript code for acf_blocks/header-banner component
(($) => {
    "use strict";
    console.log("acf_blocks/header-banner scripts loaded...");

    $(document).ready(() => {
        const $hero = $(".image-banner-col img").first();
        if (!$hero.length) return;

        // Verify GSAP is available
        if (typeof gsap === "undefined") {
            console.error("GSAP is not loaded.");
            return;
        }

        // Build timeline from the values already set in CSS
        gsap.timeline({ defaults: { ease: "power3.out" } })
            // bg image zoom & fade
            .to($hero, {
                duration: 2, // Smooth long transition
                scale: 1, // Increased zoom effect (was 1.08)
                opacity: 1
            })
            // headline cascade
            .to(".hero-area__headline", {
                duration: 3,
                y: 0,
                opacity: 1,
                stagger: 0.5
            }, "-=1.5"); // Overlap animations
    });

})(jQuery);
